// Fixed numbers and pt-BR copy from the spec and plan. User-facing strings are
// pt-BR; identifiers stay English (product law).

/** v1 seeds exactly these rooms; slug and title are equal (spec §2, §5). */
export const FIXED_ROOM_SLUGS = ['1', '2', '3', '4'] as const;
export type FixedRoomSlug = (typeof FIXED_ROOM_SLUGS)[number];

/** room_finished + 30 min: unresolved intents become failed (spec §6.2). */
export const RECORDING_DEADLINE_MS = 30 * 60 * 1000;
/** room_finished + 24 h: no audio of the meeting may exist after this (spec §6.3). */
export const TRANSCRIPTION_DEADLINE_MS = 24 * 60 * 60 * 1000;

/** One recording meeting at a time in v1 (spec §6.4). */
export const MAX_CONCURRENT_RECORDINGS = 1;
/** Below this, a new meeting runs with recording_mode = unavailable. */
export const SCRATCH_MIN_FREE_BYTES = 2 * 1024 ** 3;
/** Below this, alert the owner. */
export const SCRATCH_ALERT_FREE_BYTES = 5 * 1024 ** 3;

/** Presence: the web polls every 4 s; the api serves data at most 1 s old (plan). */
export const PRESENCE_POLL_INTERVAL_MS = 4000;
export const PRESENCE_MAX_CACHE_AGE_MS = 1000;

/** LiveKit data topic peers use to flip "Gravar" to "Gravando" at once (best effort; v3.8). */
export const RECORDING_DATA_TOPIC = 'recording';

/** Chunking target and provider limit for whisper-1 (spec §6.3). */
export const CHUNK_TARGET_BYTES = 20 * 1024 * 1024;
export const TRANSCRIPTION_UPLOAD_LIMIT_BYTES = 25 * 1024 * 1024;

/** Periodic sweeps (spec §6.2, §6.4). */
export const RECONCILE_INTERVAL_MS = 5 * 60 * 1000;
export const JANITOR_INTERVAL_MS = 15 * 60 * 1000;

/** Summary bodies render as bounded plain text (spec §5). */
export const SUMMARY_RENDER_MAX_CHARS = 20_000;

/** Pagination for list endpoints (docs/contracts.md). */
export const PAGE_DEFAULT_LIMIT = 20;
export const PAGE_MAX_LIMIT = 100;

export const SHARED_MIC_LABEL = 'microfone compartilhado (falante não identificado)';
export const RECORDING_UNAVAILABLE_LABEL = 'sem gravação disponível';
export const EMPTY_ROOM_LABEL = 'vazia';
export const PRESENCE_UNAVAILABLE_LABEL = 'presença indisponível';
